// extracted by mini-css-extract-plugin
module.exports =  {"modal-content-slim":"PWDTQJD","modalContentSlim":"PWDTQJD"};